import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const buildPhoneString = (address, mapUserPatient) => {
    const userNumber = mapUserPatient?.User?.contact_no || '';
    const patientNumber = mapUserPatient?.Patient?.contact_no || '';
    const addressNumber = address?.phone || '';
    const uniqueSet = new Set([userNumber, patientNumber, addressNumber]);
    uniqueSet.delete('');
    return Array.from(uniqueSet).join(',');
};

const OrderAddressPrintLabel = ({ address, orderId, billNo, mapUserPatient }) => {
    const phoneString = useMemo(
        () => buildPhoneString(address, mapUserPatient),
        [address, mapUserPatient]
    );

    if (!address) {
        return null;
    }

    return (
        <div id="section-to-print" className="flex flex-row gap-1 w-full justify-start items-start uppercase">
            <div className="w-full">
                <h3 className="!text-[15px]">To,</h3>
                <div className="w-[100%] flex flex-col gap-2 mt-2">
                    <div className="flex flex-col gap-2 w-full font-semibold flex-1">
                        <div className="flex flex-row items-center w-full">
                            <h5 className="text-[15px] flex-1">
                                NAME: &nbsp; {address?.name?.toUpperCase() || ''}
                            </h5>
                            <h5 className="text-[15px] whitespace-nowrap ml-4">
                                ORDER ID: &nbsp; {orderId || ''}
                            </h5>
                        </div>
                        <div className="flex flex-row items-center w-full">
                            <h5 className="text-[15px] flex-1">
                                PHONE: &nbsp; {phoneString || address?.phone || ''}
                            </h5>
                            {billNo && (
                                <h5 className="text-[15px] whitespace-nowrap ml-4">
                                    BILL NO: &nbsp; {billNo}
                                </h5>
                            )}
                        </div>
                    </div>
                    <div className="w-2/3 flex text-[15px] flex-row font-semibold flex-1">
                        <h5>
                            ADDRESS: &nbsp;
                            {address?.line ? `${address.line} ` : ''}
                            {address?.district ? `${address.district} ` : ''}
                            {address?.state ? `${address.state} ` : ''}
                            {address?.pincode || ''}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

OrderAddressPrintLabel.propTypes = {
    address: PropTypes.object,
    orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    billNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mapUserPatient: PropTypes.object,
};

export default OrderAddressPrintLabel;
